import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.div ``;
const ListHeader = styled.span `
  ${fonts.brandonGrotesque.bold};
  display: flex;
  font-size: 18px;
  line-height: 42px;
  text-transform: uppercase;
  place-content: center;
  gap: 12px;

  svg {
    width: 16px;
    ${transition('transform')};

    [data-open='true'] & {
      transform: rotate(0.5turn);
    }
  }

  @media ${from(Device.TabletLarge)} {
    line-height: 24px;
    justify-content: flex-start;

    svg {
      display: none;
    }

    [data-view='inline'] & {
      display: none;
    }
  }
`;
const List = styled.ul `
  ${transition('max-height', 0.5)};
  height: auto;
  overflow: hidden;

  [data-open='false'] & {
    max-height: 0px;
  }

  [data-open='true'] & {
    max-height: 500px;
  }

  @media ${from(Device.TabletLarge)} {
    [data-open] & {
      max-height: 100%;
      overflow: visible;
    }
  }
`;
const ListItem = styled.li `
  text-align: center;
  margin: 16px 0;

  @media ${until(Device.TabletLarge)} {
    &:first-child {
      margin-top: 8px;
    }
  }

  @media ${from(Device.TabletLarge)} {
    text-align: left;

    [data-view='inline'] & {
      position: relative;
      display: inline-block;
      margin: 0;
      padding: 0 20px;

      &:after {
        content: '';
        display: block;
        height: 23px;
        width: 1px;
        background-color: ${brand.greyDark};
        opacity: 0.4;
        position: absolute;
        right: 0;
        top: 0;
      }

      &:first-child {
        padding-left: 0;
      }

      &:last-child::after {
        display: none;
      }
    }
  }
`;
const ListLink = styled.a `
  ${fonts.brandonGrotesque.regular};
  color: ${brand.black};
  font-size: 16px;
  line-height: 30px;
  text-transform: uppercase;
  text-decoration: none;
  ${transition('opacity')};

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
  }

  &:hover {
    opacity: 0.4;
  }

  @media ${from(Device.TabletLarge)} {
    ${fonts.brandonGrotesque.medium};

    line-height: 16px;
    margin-bottom: 10px;
  }
`;
const LinkListStyles = {
    Container,
    ListHeader,
    List,
    ListItem,
    ListLink,
};
export default LinkListStyles;
